import { PlaylistAssignmentsTablePage, usePlaylistAssignmentsParams, usePlaylistAssignmentsPortals, PlaylistAssignmentsPortalsTable, PlaylistAssignmentsPortalsList, getPlaylistAssignmentsUrl, PlaylistAssignmentsBlankPage, PlaylistAssignmentsForPortal } from '..';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { FILTER_TYPES } from '../../../constants/TopFilterConstants';
import useNavigate from '../../../hooks/useNavigate';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import { AssignPlaylistButton } from './AssignPlaylistButton';
import { jsx as _jsx } from "react/jsx-runtime";
const PlaylistAssignmentsPortalsCount = ({
  count
}) => {
  return /*#__PURE__*/_jsx(FormattedMessage, {
    message: `learningCenter.playlistAssignments.portalsCount`,
    options: {
      count
    }
  });
};
const PlaylistAssignmentsPortals = ({
  playlistId: propPlaylistId
}) => {
  const {
    isMobile
  } = useMediaQuery();
  const {
    playlistId: paramPlaylistId
  } = usePlaylistAssignmentsParams();
  const playlistId = propPlaylistId || paramPlaylistId;
  const navigate = useNavigate();
  const {
    total,
    playlistAssignmentsPortals,
    playlistAssignmentsPortalsLoading: isLoading
  } = usePlaylistAssignmentsPortals({
    playlistId
  });
  if (!playlistId || isLoading) return null;
  if (!total) return /*#__PURE__*/_jsx(PlaylistAssignmentsBlankPage, {
    playlistId: playlistId
  });

  // render assignments directly if it only has one portal
  if (total === 1 && playlistAssignmentsPortals && playlistAssignmentsPortals.length) return /*#__PURE__*/_jsx(PlaylistAssignmentsForPortal, {
    playlistId: playlistId,
    portalId: playlistAssignmentsPortals[0].portal.id
  });
  const handleOnRowOpenChange = portalId => navigate(getPlaylistAssignmentsUrl(playlistId, portalId));
  return /*#__PURE__*/_jsx(PlaylistAssignmentsTablePage, {
    actions: /*#__PURE__*/_jsx(AssignPlaylistButton, {
      playlistId: playlistId,
      style: {
        overflow: 'visible'
      }
    }),
    enabledFilters: [FILTER_TYPES.SEARCH_TEAMS],
    headerTitle: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "learningCenter.playlistAssignments.portalsHeader"
    }),
    tableCount: /*#__PURE__*/_jsx(PlaylistAssignmentsPortalsCount, {
      count: total
    }),
    children: isMobile ? /*#__PURE__*/_jsx(PlaylistAssignmentsPortalsList, {
      onRowOpenChange: ({
        portal: {
          portal: {
            id
          }
        }
      }) => handleOnRowOpenChange(id),
      playlistId: playlistId,
      renderRowContents: null
    }) : /*#__PURE__*/_jsx(PlaylistAssignmentsPortalsTable, {
      playlistId: playlistId
    })
  });
};
export default PlaylistAssignmentsPortals;